export const SET_DRUG_LABEL_LIST = 'SET_DRUG_LABEL_LIST';
